import React from 'react'
import { ActionLink } from '../../ui/ActionLink'
import { formatCurrency } from '../../../utils/currency'

interface LeaseItemProps {
  numero: number
  marca: string
  modelo: string
  valorFactura: number
  onViewDetails?: () => void
}

// Tarjeta de arrendamiento para "Mis arrendamientos" — mismo lenguaje
// visual que PendingProposalItem (tarjeta blanca, grid de columnas
// label/valor), pero sin badge de estatus y con los campos de la
// referencia de diseño.
const LeaseItem: React.FC<LeaseItemProps> = ({
  numero,
  marca,
  modelo,
  valorFactura,
  onViewDetails,
}) => {
  return (
    <div className="w-full bg-white rounded-lg shadow-md border border-gray-200 p-3 sm:p-6 mb-4 text-left">
      {/* Mobile Layout */}
      <div className="block sm:hidden">
        <h3 className="text-lg font-semibold text-gray-900 mb-3">
          Arrendamiento {numero}
        </h3>

        <div className="space-y-2 mb-3">
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Marca:</span>
            <span className="text-xs font-medium text-gray-900">{marca}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Modelo:</span>
            <span className="text-xs font-medium text-gray-900">
              {modelo}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Valor factura:</span>
            <span className="text-xs font-medium text-gray-900">
              {formatCurrency(valorFactura)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-xs text-gray-500">Próximo pago:</span>
            {/* TODO: el backend todavía no expone la fecha del próximo
                pago — placeholder fijo hasta que exista ese campo. */}
            <span className="text-xs font-medium text-gray-900">—</span>
          </div>
        </div>

        <div className="flex justify-end">
          <ActionLink label="Ver detalles" onClick={onViewDetails} />
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden sm:flex items-center gap-4">
        <div className="flex-1">
          <h3 className="text-xl font-semibold text-gray-900 mb-4">
            Arrendamiento {numero}
          </h3>

          <div className="grid grid-cols-12 gap-6">
            <div className="col-span-3">
              <p className="text-sm text-gray-500 mb-1">Marca</p>
              <p className="text-sm font-medium text-gray-900 truncate">
                {marca}
              </p>
            </div>

            <div className="col-span-3">
              <p className="text-sm text-gray-500 mb-1">Modelo</p>
              <p className="text-sm font-medium text-gray-900 truncate">
                {modelo}
              </p>
            </div>

            <div className="col-span-3">
              <p className="text-sm text-gray-500 mb-1">Valor factura</p>
              <p className="text-sm font-medium text-gray-900">
                {formatCurrency(valorFactura)}
              </p>
            </div>

            <div className="col-span-3">
              <p className="text-sm text-gray-500 mb-1">Próximo pago</p>
              {/* TODO: el backend todavía no expone la fecha del próximo
                  pago — placeholder fijo hasta que exista ese campo. */}
              <p className="text-sm font-medium text-gray-900">—</p>
            </div>
          </div>
        </div>

        <div className="shrink-0">
          <ActionLink label="Ver detalles" onClick={onViewDetails} />
        </div>
      </div>
    </div>
  )
}

export default LeaseItem
